export const FILE_SIZE_LIMIT = 100 * 1024 * 1024; // 100MB in bytes
